import React from 'react';
import KEYBlue from '../common/keylist-blue';
type Props = {
    title: string;
};

const CreatePowerFully: React.FC<Props> = () => {
    return (
        <section className="Development-Services section-py mb-5 ">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10 items-end">
                    <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
                        <div className="dev-service-inner">
                            <h2 className="fw-700 fs-xl">
                                Create Powerfully & Natively Compiled Experiences Using {`Flutter'`}s Dart SDK
                            </h2>
                            <p className="fs-md text-secondary fw-400">
                                In the fast-paced world of{' '}
                                <a href="mobile-app-development" target="_self" className="text-blue-400">
                                    mobile app development
                                </a>
                                , speed, efficiency, and user experience reign supreme. Moweb, a leading Flutter app development
                                company, empowers businesses to achieve these goals and more. We specialize in building stunning,
                                natively compiled applications for iOS and Android using {`Google's`} revolutionary Flutter
                                framework. Our team of seasoned Flutter developers is dedicated to crafting exceptional mobile
                                experiences that captivate users and drive business growth.
                            </p>
                            <p className="fs-md text-secondary fw-400">
                                Flutter, powered by the Dart programming language, is a game-changer in the world of
                                cross-platform app development. It offers a unique blend of speed, performance, and flexibility,
                                making it the ideal choice for businesses seeking to reach a wider audience without compromising
                                on quality.
                            </p>
                        </div>
                    </div>
                    <div className="xl:col-span-6 lg:col-span-6 md:col-span-9 mb-[-60px]">
                        <p className="fs-md text-secondary  mb-2.5 font-semibold">
                            {` Here’s`} why businesses are choosing Flutter for their mobile app development:{' '}
                        </p>
                        <div className="row grid grid-cols-1">
                            <div>
                                <div className=" ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px] mb-5 ">
                                                    <span className="font-semibold text-black">Single Codebase:</span>
                                                    {''} Build cross-platform apps with a single codebase.
                                                </p>
                                            </>
                                        }
                                    />
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px] mb-5">
                                                    <span className="font-semibold text-black">Cost-Efficiency:</span>
                                                    {''} Flutter app development services reduce costs with faster development
                                                    cycles.
                                                </p>
                                            </>
                                        }
                                    />
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px] mb-5">
                                                    <span className="font-semibold text-black">Scalable Solutions:</span>
                                                    {''} Flutter apps offer high performance and scalability.
                                                </p>
                                            </>
                                        }
                                    />
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px] mb-5">
                                                    <span className="font-semibold text-black">Custom UI/UX:</span>
                                                    {''} Flutter supports customizable UI/UX, enabling intuitive user experiences.
                                                </p>
                                            </>
                                        }
                                    />
                                    <KEYBlue
                                        text={
                                            <>
                                                <p className="font-normal text-[17px] mb-5">
                                                    <span className="font-semibold text-black">Seamless Integration:</span>
                                                    {''} Integrate with existing systems and ensure high compatibility across
                                                    platforms.
                                                </p>
                                            </>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CreatePowerFully;
